import { errorToast, successToast } from "@design-system/components/toast";
import { telegramLoginAtom } from "@framework/auth/atoms";
import { useAction } from "@framework/shared/hooks/useAction";
import { trans } from "@mongez/localization";
import { FormSubmitOptions } from "@mongez/react-form";

export function useTelegramLogin() {
  const submit = useAction("/telegram/login");

  const loginWithTelegram = async (options: FormSubmitOptions) => {
    telegramLoginAtom.change("phoneOrEmail", options.values.phoneOrEmail);

    const result = await submit({ phoneOrEmail: options.values.phoneOrEmail });

    if (result.error) {
      options.form.submitting(false);
      return errorToast(result.error);
    }

    telegramLoginAtom.change("isOTPSent", true);
    successToast(trans("auth.telegram.otpSent"));
  };

  return {
    loginWithTelegram,
  };
}
